import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ArchiveIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 24 21",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21),
    children: [/*#__PURE__*/jsx("path", {
      d: "m21.75 8.25v9a3 3 0 0 1 -3 3h-13.5a3 3 0 0 1 -3-3v-9"
    }), /*#__PURE__*/jsx("path", {
      d: "m21.75.75h-19.5a1.5 1.5 0 0 0 -1.5 1.5v3h22.5v-3a1.5 1.5 0 0 0 -1.5-1.5z"
    }), /*#__PURE__*/jsx("path", {
      d: "m15 9.75a1.5 1.5 0 0 1 -1.5 1.5h-3a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 1.5 1.5z"
    })]
  });
};

export { PM2ArchiveIcon };
//# sourceMappingURL=archive.js.map
